import type { FC } from "react";
import { type match, Route, Switch } from "react-router-dom";
import ComponentLoader, { EComponentList } from "../general/ComponentLoader/ComponentLoader";

export interface ProductListWrapperProps {
	match: match<any>;
	location: Location;
}

const ProductList = ({ match }: { match: match<any> }) => (
	<ComponentLoader componentName={EComponentList.ProductList} match={match} />
);

const ProductListWrapper: FC<ProductListWrapperProps> = ({ match }) => {
	return (
		<Switch>
			<Route path={match.path} render={ProductList} />
		</Switch>
	);
};

export default ProductListWrapper;
